<form
  #form="ngForm"
  (ngSubmit)="form.valid ? submit() : setFormDirty(form.control)"
>
  <div class="input__container">
    <label for="name">Namn</label>
    <input
      id="name"
      name="name"
      type="text"
      [(ngModel)]="behavior.name"
      required
    />
  </div>

  <div class="input__container">
    <label for="tag">Tagg</label>
    <input
      id="tag"
      name="tag"
      type="text"
      [(ngModel)]="behavior.tag"
      required
    />
  </div>

  <table class="table table-woo table--info table--hover width--100">
    <thead>
      <tr>
        <th class="capitalize--first-letter centered" colspan="2"></th>
        <th class="capitalize--first-letter centered" colspan="3">
          Estimatfördelning
        </th>
        <th class="capitalize--first-letter centered" colspan="3">
          Maxuttag
        </th>
      </tr>
      <tr>
        @for (header of tableHeaders; track $index) {
          <th class="text--thin text--small capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (
        row of inputRows;
        let rIdx = $index;
        track row.productFormatId + '-' + row.publisherId
      ) {
        @if (rowVisible(row)) {
          <tr>
            <td class="text--thin vertical-align--middle">
              {{ translateProductFormat(row.productFormat) }}
            </td>
            <td class="text--thin vertical-align--middle">
              {{ row.publisher }}
            </td>

            @for (slot of ['preroll', 'midroll', 'postroll']; track slot) {
              <td class="vertical-align--middle">
                <div class="input__container">
                  <input
                    name="row-{{ rIdx }}-shares-{{ slot }}"
                    [(ngModel)]="
                      behavior.shares[row.publisherId][row.productFormatId][slot]
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes[row.productFormatId][slot]"
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId][slot]
                    "
                  />
                </div>
              </td>
            }

            @for (slot of ['preroll', 'midroll', 'postroll']; track slot) {
              <td class="vertical-align--middle">
                <div class="input__container">
                  <input
                    name="row-{{ rIdx }}-limits-{{ slot }}"
                    [(ngModel)]="
                      behavior.withdrawal_limits[row.publisherId][
                        row.productFormatId
                      ][slot]
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="includedProductFormatSlotTypes[row.productFormatId][slot]"
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId][slot]
                    "
                  />
                </div>
              </td>
            }
          </tr>
        }
      }
    </tbody>
  </table>

  <div class="margin-top-bottom--1x">
    <h5>Bokningsbar</h5>
    <toggle
      [(ngModel)]="behavior.active"
      name="{{ behavior.name }}-bookable"
      onLabel="Ja"
      offLabel="Nej"
    ></toggle>
  </div>

  <button type="submit" class="button primary-1">Skapa</button>
  <button type="button" class="link primary" (click)="onAbort.emit()">
    Avbryt
  </button>
</form>
